import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

import routes from './routes-admin';
import store from '../state/store';

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: 'page',
});

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  const publicPages = [
    'admin',
    'landing',
    'login',
    'printPage',
    'ForgotPassword',
    'printEirInUser',
    'printEirOutUser',
  ];

  const authpage = publicPages.includes(routeTo.name);
  let loggeduser =
    store.state.user && store.state.user.company ? store.state.user : null;
  const LocalDataVuex =
    localStorage.getItem('user_dkm') &&
    localStorage.getItem('user_dkm') !== 'undefined'
      ? JSON.parse(localStorage.getItem('user_dkm'))
      : false;

  if (LocalDataVuex && LocalDataVuex.access_token && !loggeduser) {
    let data_user = await store.dispatch('getUserInfo');
    loggeduser = data_user;
  }

  // check expired time jwt token
  if (LocalDataVuex && LocalDataVuex.expired_token) {
    let current_time = new Date();
    if (LocalDataVuex.expired_token) {
      if (new Date(LocalDataVuex.expired_token) < current_time) {
        localStorage.clear();
        return next('/');
      }
    }
  }

  if (authpage === false && !loggeduser) {
    localStorage.clear();
    return next('/');
  } else if (loggeduser && authpage) {
    if (loggeduser && loggeduser && loggeduser.id_principle) {
      return next('/usr/dashboard');
    } else {
      if (loggeduser) {
        return next(loggeduser.default_route);
      } else {
        return next();
      }
    }
  } else if (loggeduser) {
    // set hak akses khusus user admin
    if (loggeduser && loggeduser && !loggeduser.id_principle) {
      const { modulName, pageName, pageType } = routeTo.meta;
      if (
        modulName &&
        modulName !== '' &&
        pageName &&
        pageName !== '' &&
        pageType
      ) {
        let user_permission = loggeduser.user_permission || [];
        let check_permission = user_permission.filter(
          (item) => item.name === pageName && item.modul === modulName
        );

        if (pageType && pageType.indexOf('_') !== -1) {
          if (pageType === 'create_update') {
            const { params } = routeTo;
            if (params && params.id) {
              // jika methode edit
              if (check_permission[0]['update']) {
                return next();
              } else {
                store.dispatch('notification/showNotif', {
                  message:
                    'Tidak dapat mengubah data ' + check_permission[0].label,
                  type: 'error',
                });

                next(loggeduser.default_route);
              }
            } else {
              // jika methode create
              if (check_permission[0]['create']) {
                return next();
              } else {
                store.dispatch('notification/showNotif', {
                  message:
                    'Tidak dapat menambah data ' + check_permission[0].label,
                  type: 'error',
                });

                next(loggeduser.default_route);
              }
            }
          }
        } else {
          if (check_permission[0]) {
            if (check_permission[0][pageType]) {
              return next();
            }
          }

          store.dispatch('notification/showNotif', {
            message: 'Anda tidak memiliki akses ke halaman ini',
            type: 'error',
          });

          return next(loggeduser.default_route);
        }
      }
    }
  }

  next();
});

export default router;
